export const getDeviceAuthNeeded = (state) => state.adom.deviceAuthNeeded || [];
